import React, { useState } from 'react';
import { useSnackbar } from '../../../../context/SnackBarContext';
import MultipleSelect from '../../../../component/MultipleSelect';

export const EditPurchaseOrderForm = ({
    setFormData,
    formData,
    setModalOpen,
    updateFunc,
    tableData,
    setTableData
}) => {
    const { showError } = useSnackbar();
    const [newColor, setNewColor] = useState('');

const recalculateTable = (issueQty, colorsLength) => {
    const totalColors = colorsLength || 1;
    setTableData((prev) => {
        const updatedItems = prev.item.map((itm) => {
            const avg = parseFloat(itm.avg) || 0;
            const rate = parseFloat(itm.rate) || 0;

            const colQty = (issueQty / totalColors) * avg;
            const quantity = colQty * totalColors;
            const total = quantity * rate;

            return {
                ...itm,
                colQty: Number(colQty.toFixed(2)),
                quantity: Number(quantity.toFixed(2)),
                total: Number(total.toFixed(2)),
            };
        });
        return {
            ...prev,
            item: updatedItems,
        };
    });
};



    const handleAddColor = () => {
        const trimmedColor = newColor.trim();
        if (!trimmedColor) return showError("Color cannot be empty");
        if (formData.color.includes(trimmedColor)) return showError("Color already added");

        const updatedColors = [...formData.color, trimmedColor];
        setFormData((prev) => ({ ...prev, color: updatedColors }));
        recalculateTable(parseFloat(formData.issueQuantity || 0), updatedColors.length);
        setNewColor('');
    };

    const handleDeleteColor = (indexToDelete) => {
        const updatedColors = formData.color.filter((_, i) => i !== indexToDelete);
        setFormData((prev) => ({ ...prev, color: updatedColors }));
        recalculateTable(parseFloat(formData.issueQuantity || 0), updatedColors.length);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "issueQuantity") {
            const issueQty = parseFloat(value) || 0;
            recalculateTable(issueQty, formData.color.length);
        }

        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSaveButton = () => {
        setModalOpen(true);
    };

    const optionsSize = [
        { name: 'Small' },
        { name: 'Medium' },
        { name: 'Large' },
    ];

    const optionsDelivery = [
        { name: 'Home' },
        { name: 'Office' },
        { name: 'Pickup Point' },
    ];

    const handleChooseStyle = () => {
        if (!(formData.issueQuantity + '').trim()) {
            showError("Please enter the Issue Quantity before selecting a style name.");
            return;
        }
        updateFunc({ isProductDrawerOpen: true });
    };

    const total = Math.round(
        tableData.item.reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0)
    );

    return (
        <div>
            <div className="flex justify-between items-center mb-4 bg-[#f4f5f7] pb-3 md:px-0 px-3">
                <h2 className="md:text-[28px] text-[20px] font-bold text-gray-800">Edit Purchase Order</h2>
                <button
                    onClick={handleSaveButton}
                    className="md:px-4 px-2 md:py-2 py-1 bg-gray-800 text-white border-gray-400 border rounded hover:bg-black"
                >
                    Save
                </button>
            </div>

            <div className="md:px-5 px-2">
                <div className="flex justify-start pt-3">
                    <div className="flex flex-row justify-center items-center mb-4">
                        <p className="text-gray-700 mr-2">Total :</p>
                        <span className="text-gray-700 text-[24px] font-bold">₹{total || "0.00"}</span>
                    </div>
                </div>

                <div className="mb-4">
                    <button
                        onClick={handleChooseStyle}
                        className="md:px-4 px-2 md:py-2 py-1 bg-gray-800 text-white border-gray-400 border rounded hover:bg-black"
                    >
                        Choose Style Name
                    </button>
                </div>

                <div className="grid md:grid-cols-6 gap-4 mb-6 max-w-[1000px] mt-5">
                    <InputField label="Supplier" name="supplier" value={formData.supplier} handleChange={handleChange} />
                    <div className="mb-4">
                        <label className="block text-sm font-bold text-gray-700 mb-2">Size</label>
                        <MultipleSelect
                            label="Size"
                            options={optionsSize}
                            value={formData.size}
                            onChange={handleChange}
                            name="size"
                            placeholder="Size"
                        />
                    </div>
                    <InputField label="Fabricator" name="fabricator" value={formData.fabricator} handleChange={handleChange} />
                    <InputField label="Style No" name="styleNo" value={formData.styleNo} handleChange={handleChange} />
                    <InputField label="Style Name" name="styleName" value={formData.styleName} handleChange={handleChange} disabled />
                    <InputField label="Remarks" name="remarks" value={formData.remarks} handleChange={handleChange} />
                </div>

                <div className="grid md:grid-cols-6 gap-4 mb-6 max-w-[1000px] mt-4">
                    <InputField type="date" label="Dated *" name="dated" value={formData.dated} handleChange={handleChange} />
                    <InputField type="date" label="Order Date *" name="deliveryDate" value={formData.deliveryDate} handleChange={handleChange} />
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Delivery At</label>
                        <MultipleSelect
                            label="Delivery At"
                            options={optionsDelivery}
                            value={formData.deliveryAt}
                            onChange={handleChange}
                            name="deliveryAt"
                            placeholder="Delivery At"
                        />
                    </div>
                    <InputField
                        label="Issue Quantity*"
                        name="issueQuantity"
                        value={formData.issueQuantity}
                        handleChange={handleChange}
                        type="number"
                    />

                    {/* Color Input and Display */}
                    <div className="mb-6 space-y-4 col-span-2">
                        <div className="flex flex-col md:flex-row md:items-end gap-4">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Color</label>
                                <input
                                    type="text"
                                    value={newColor}
                                    onChange={(e) => setNewColor(e.target.value)}
                                    className="w-full md:w-[200px] border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Add color"
                                />
                            </div>
                            <button
                                onClick={handleAddColor}
                                className="bg-gray-800 text-white px-6 py-2 rounded hover:bg-black w-full md:w-[200px]"
                            >
                                Add Color
                            </button>
                        </div>

                        {formData.color.length > 0 && (
                            <div className="flex flex-col gap-2">
                                <span className="font-semibold text-gray-700">Selected Colors:</span>
                                <div className="flex flex-wrap gap-2">
                                    {formData.color.map((clr, index) => (
                                        <span
                                            key={index}
                                            className="flex items-center bg-gray-200 text-sm px-3 py-1 rounded-full shadow-sm"
                                        >
                                            <span className="text-gray-800">{clr}</span>
                                            <button
                                                onClick={() => handleDeleteColor(index)}
                                                className="ml-2 text-red-600 hover:text-red-800 font-bold focus:outline-none"
                                                title="Remove"
                                            >
                                                ✕
                                            </button>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// Reusable Input Field Component
const InputField = ({ label, name, value, handleChange, type = "text", disabled = false }) => (
    <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">{label}</label>
        <input
            type={type}
            name={name}
            value={value}
            onChange={handleChange}
            disabled={disabled}
            className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
            placeholder={label}
        />
    </div>
);
